import MugedaResource from "external-mugeda-resource-bundle";

type initDataProp = {
  mode: "h5" | 'rich';
  multiple?: boolean;
  target?: HTMLElement;
  mode_win?: boolean;
  showImportDataButton?: boolean;
  width?: number;
  height?: number;
  theme?: "dark" | "bright2";
  resourceClassName?: string;
  importData?: (res: any) => void;
  tabData?: Array<{
    name: string;
    type: string;
    args: Array<{
      version: number;
    }>;
    sort: string[];
    folderNameReplace: Array<{
      resKey: string;
      replaceName: string;
      hidden: boolean;
    }>;
  }>;
};

declare global {
    interface Window {
        MugedaResource: any
    }
}

const useInitResource = (initData: initDataProp, callback: any) => {
  const _MugedaResource = MugedaResource
    ? MugedaResource.getMugedaResource()
    : window.MugedaResource.getMugedaResource();

  const tableImage = [
    {
      name: "图片",
      type: "image",
      args: [
        {
          version: 3,
        },
      ],
      sort: ["private", "shared", "public"],
      folderNameReplace: [
        {
          resKey: "private",
          replaceName: "个人",
          hidden: false,
        },
        {
          resKey: "shared",
          replaceName: "部门",
          hidden: false,
        },
        {
          resKey: "public",
          replaceName: "公共",
          hidden: false,
        },
      ],
    },
  ];
  _MugedaResource.init({
    target: document.getElementById("mugeda-ai-tool-resource"),
    mode: "window",
    tabData: initData.tabData ? initData.tabData : tableImage,
    mode_win: true,
    showImportDataButton: true,
    width: 715,
    height: 600,
    theme: initData.mode === "h5" ? "dark" : "bright2",
    multiple: typeof initData.multiple === "boolean" ? initData.multiple : true,
    resourceClassName: "ai-resource",
    importData: function (res: any) {
      callback && callback(res);
      _MugedaResource.hide();
    },
  });

  return _MugedaResource;
};

const useShowResource = (_MugedaResource) => {
  _MugedaResource.reset();
  _MugedaResource.show();
};

const useDestroyResource = (_MugedaResource) => {
  _MugedaResource.destory();
};

export { useInitResource, useShowResource, useDestroyResource };
